import React, { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ImageIcon, Loader2, X } from "lucide-react";
import { uploadKycFile, kycDocRef } from "@/lib/kyc";
import { SecureDocImage } from "@/components/kyc/SecureDocImage";

// Role-proof images for « Envoyer ma preuve » / complements: private encrypted KYC storage
// (POST /kyc/documents → "kycdoc:{id}" refs), never the generic feed upload pipeline.
export const KycProofUploader = ({ docs = [], onChange, buttonLabel, testId = "kyc-proof", max = 5 }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (files) => {
    const list = Array.from(files || []).slice(0, Math.max(0, max - docs.length));
    if (!list.length) return;
    setBusy(true);
    const added = [];
    for (const f of list) {
      try { const d = await uploadKycFile("/kyc/documents", f); added.push(d.ref); }
      catch (e) { toast.error(`${f.name} : ${e?.friendlyMessage || e?.message || "Erreur"}`); }
    }
    setBusy(false);
    if (added.length) onChange([...docs, ...added].slice(0, max));
  };
  return (
    <div>
      <input ref={ref} type="file" accept="image/*" multiple className="hidden" data-testid={`${testId}-upload-input`} onChange={(e) => { pick(e.target.files); e.target.value = ""; }} />
      <Button type="button" size="sm" variant="outline" className="rounded-full" onClick={() => ref.current?.click()} disabled={busy || docs.length >= max} data-testid={`${testId}-upload-btn`}>
        {busy ? <Loader2 size={14} className="animate-spin mr-1" /> : <ImageIcon size={14} className="mr-1" />} {buttonLabel}
      </Button>
      {docs.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2" data-testid={`${testId}-docs`}>
          {docs.map((d, i) => (
            <div key={i} className="relative">
              {kycDocRef(d) ? <SecureDocImage path={`/kyc/identity/documents/${kycDocRef(d)}`} size="h-14 w-14" testId={`${testId}-doc-${i}`} /> : <span className="chip text-[10px]">{String(d).slice(0, 24)}</span>}
              <button type="button" onClick={() => onChange(docs.filter((_, idx) => idx !== i))} className="absolute -top-1.5 -right-1.5 h-5 w-5 rounded-full bg-black/70 text-white grid place-items-center" data-testid={`${testId}-remove-${i}`}><X size={11} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
